import { useContext } from 'react';
import App from '../App';
import configs from '../Configs';
import Heading from 'sharp-component-library/build/Heading';
import { AuthContext, AuthProvider } from 'react-oauth2-code-pkce';

window.Buffer = window.Buffer || require("buffer").Buffer;

export const SecureApp = () => {
  const {token, tokenData, logIn, loginInProgress} = useContext(AuthContext);
  const state = Buffer.from(globalThis.window.location.href.toString()).toString('base64');

  if(loginInProgress){
    return (
      <div data-testid={'login-pending'}>
        <Heading level={2}>Sharp SSO - Please wait...</Heading>
      </div>
    );
  }

  if (!token) {
    logIn()
  } else {
    if( tokenData?.exp ){
      const now = new Date();
      const exp = tokenData.exp * 1000;
      if(now.getTime() > exp){
        return (
          <div data-testid={'token-expired'}>
            {logIn()}
          </div>
        );
      }
    }
  }

  return (
    <div data-testid={'app'}>
      <App />
    </div>
  );
}

const SecureWrapper = () => {
  const oAuthConfig = configs().okta;
  const state = Buffer.from(globalThis.window.location.pathname ? globalThis.window.location.pathname.toString() : '/find-a-doctor/providers').toString('base64');

  const authConfig = {
    clientId: oAuthConfig.clientId,
    authorizationEndpoint: oAuthConfig.authorizationEndpoint,
    tokenEndpoint: oAuthConfig.tokenEndpoint,
    redirectUri: oAuthConfig.redirectUri,
    loginMethod: 'redirect',
    autoLogin: true,
    scope: 'openid',
    clearURL: false,
    extraAuthParameters: { state: state },
    storageKeyPrefix: 'PAT_',
    postLogin: () => {
      const queryParams = new URLSearchParams(globalThis.window.location.search);
      const state = queryParams.get('state');
      if(state){
        globalThis.window.location.href = atob(state);
      }
    },
  }
  return (
    <div data-testid='secure-wrapper'>
      <AuthProvider authConfig={authConfig}>
        <SecureApp />
      </AuthProvider>
    </div>
  );
}

export default SecureWrapper;